import type { CompanyRole } from "~/lib/api";

type Props = {
  role: CompanyRole;
};

export function ObservedRoleCard(props: Props) {
  const seen = () => {
    const raw = props.role.last_seen_at;
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? raw : d.toLocaleDateString();
  };

  return (
    <a class="intel-block-card" href={props.role.apply_url} target="_blank" rel="noreferrer">
      <strong>{props.role.title}</strong>
      <span class="muted">
        {props.role.location ?? "Location not listed"} · Seen {seen()}
      </span>
    </a>
  );
}
